// extracted by mini-css-extract-plugin
export default {"scroll":"table-root_scroll__SoBzI","table-container":"table-root_table-container__OsNwd"};